module.exports = __webpack_public_path__ + "images/landing-page-bg.jpg";